// extracted by mini-css-extract-plugin
module.exports = {"create-form":"CreateForm_create-form__oKTmd","create-form-title":"CreateForm_create-form-title__crFKK"};